// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"31":"BusinessSignUpModalEntry","629":"BusinessSignInModalEntry"}[chunkId] + "." + {"31":"6a68f8d0616be8e2a9e1","629":"756d34a912fcfcc22139"}[chunkId] + ".js";
};